import { Fragment} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Calendar from 'react-calendar';
import { parse, format, addDays, isBefore, isAfter, isEqual } from 'date-fns';
import '../../css/Calendar.css';
import '../../css/base.css';
import blueSkyView_large from '../../img/blueSkyView_large.jpg';
import blueSkyView_medium from '../../img/blueSkyView_medium.jpg';
import blueSkyView_small from '../../img/blueSkyView_small.jpg';
import { setBookingSelected, setDuration, setCost, setPage } from '../../store/AppSlice';

const DirectBooking = () => {
  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);
  const { bookings } = appstate;

  const selectDate = (date) => {    
    let bookingSelectedDate = parse(appstate.bookingSelected, 'yyyyMMdd', new Date());
    let formattedDate = format(date, "yyyyMMdd");

    if (isEqual(date, bookingSelectedDate)) {
      dispatch(setBookingSelected(null));
      dispatch(setCost(0));
      dispatch(setDuration(7));
    } else {
      dispatch(setBookingSelected(formattedDate));
      dispatch(setDuration(7));
      dispatch(setCost(getFullCost(date, 7)));
    }
  }

  const isSpecialDateInWeek = (date) => {
    let isSpecialDateFound = false;

    if (bookings != null) { 
      for (let i=0; i < 7; i++) {
        let dateToCheck = addDays(date, i);

        // Is this date a special date
        let thisYear = dateToCheck.getFullYear();
        let year = 'year' + thisYear;
        let formattedDate = format(dateToCheck, "yyyyMMdd");
  
        if (bookings[year].specialDates[formattedDate] > 0) {
          isSpecialDateFound = true;
        }    
      }
    }
    return isSpecialDateFound;

  }


  const isDurationDisabled = (duration) => {
    let bookingSelectedDate = parse(appstate.bookingSelected, 'yyyyMMdd', new Date());

    let endFirstWeekDate = addDays(bookingSelectedDate,6);
    let endSecondWeekDate = addDays(bookingSelectedDate,13);
    let endThirdWeekDate = addDays(bookingSelectedDate,20);
    let endFourthWeekDate = addDays(bookingSelectedDate,27);
    
    let secondWeekDate = addDays(bookingSelectedDate, 7);
    let thirdWeekDate = addDays(bookingSelectedDate, 14);
    let fourthWeekDate = addDays(bookingSelectedDate, 21);
    
    switch (duration) {
      case 7:
        if (isDateBooked(bookingSelectedDate) || isDateBooked(endFirstWeekDate)) {
          return true;

        } else {
          return false;
        }
      case 14:
        if (isDateBooked(bookingSelectedDate) || isDateBooked(secondWeekDate) || isDateBooked(endSecondWeekDate)) {
          return true;

        } else {

          // Is there a special date in week 2
          // If there is then disable that extra week
          if (isSpecialDateInWeek(secondWeekDate)) {
            return true
          } else {
            return false;
          }
        }
      case 21:
        if (isDateBooked(bookingSelectedDate) || isDateBooked(secondWeekDate) || isDateBooked(thirdWeekDate) || isDateBooked(endThirdWeekDate)) {
          return true;
        } else {
          // Is there a special date in week 2 or 3 
          // If there is then disable that extra week
          if (isSpecialDateInWeek(secondWeekDate) || isSpecialDateInWeek(thirdWeekDate)) {
            return true
          } else {
            return false;
          }
        }
      case 28:
        if (isDateBooked(bookingSelectedDate) || isDateBooked(secondWeekDate) || isDateBooked(thirdWeekDate) || isDateBooked(fourthWeekDate) || isDateBooked(endFourthWeekDate)) {
          return true;
        } else {
          // Is there a special date in week 2, 3 or 4
          // If there is then disable that extra week
          if (isSpecialDateInWeek(secondWeekDate) || isSpecialDateInWeek(thirdWeekDate) || isSpecialDateInWeek(fourthWeekDate)) {
            return true
          } else {
            return false;
          }
        }
      default:
        return true;
    }
  }

  const getSelectedBooking = () => {

    if (appstate.bookingSelected != null) {
      let bookingSelectedDate = parse(appstate.bookingSelected, 'yyyyMMdd', new Date());
      let selectedDate = format(bookingSelectedDate, "dd/MM/yyyy") + " for:";
      let option1 = null;
      let option2 = null;
      let option3 = null;
      let option4 = null;

      if (isDurationDisabled(7) === false) {
        option1 = <option value="7">7 days</option>
      }
      if (isDurationDisabled(14) === false) {
        option2 = <option value="14">14 days</option>
      }
      if (isDurationDisabled(21) === false) {
        option3 = <option value="21">21 days</option>
      }
      if (isDurationDisabled(28) === false) {
        option4 = <option value="28">28 days</option>
      }

      let options = 
        <Fragment>
          {option1}
          {option2}
          {option3}
          {option4}
        </Fragment>;

      return <div className="row selected-week-row">
              <div className="col-4 selected-week-duration-col">
                <div className="generalText selected-week-text-area">
                  <div className="generalTextBox">
                    <p className="selected-week-text"><strong>{selectedDate}</strong></p>
                  </div>
                </div>
              </div>
              <div className="col-4 selected-week-duration-col">
                <select className="duration-select selected-week-duration-area" value={appstate.selectedDuration} name="duration" id="trip-duration" 
                                                    onChange={(event) => {dispatch(setDuration(event.target.value));
                                                                          dispatch(setCost(getFullCost(bookingSelectedDate, event.target.value)))}}>
                  {options}
                </select>
              </div>
              <div className="col-1 selected-week-cost-col">
                <div className="generalText selected-week-text-area">
                  <div className="generalTextBox">
                    <p className="selected-week-text"><strong>£{appstate.cost}</strong></p>
                  </div>
                </div>
              </div>
              <div className="col-3 selected-week-book-btn-col">
                <p className="book-selected-date-button">
                  <span className="navigate-span">
                    <a className="book-selected-button" onClick={() => {dispatch(setPage("YOUR_PARTY"))}}>Book</a>
                  </span>
                </p>
              </div>
            </div>;
  } else {
      return null;
    }
  }

  const isBooked = (date) => {

    const { selectedDuration } = appstate;
    let bookingSelectedDate = parse(appstate.bookingSelected, 'yyyyMMdd', new Date());

    if (date < new Date()) {
      return 'disabled_day'
    }
    if (isDateBooked(date) === true) {
        return 'booked_day';
    } else {
        let endDate = addDays(bookingSelectedDate, selectedDuration-1);

        if (isEqual(date, bookingSelectedDate) || isEqual(date, endDate) ||
            (isBefore(date, endDate) && isAfter(date,bookingSelectedDate))) {
          return 'available_selected_period'
        } else {
          if (isDateSpecial(date) && getDurationOfSpecialDate(date) === 0) {
            return 'available_day'
          }

          if (isDateSpecial(date) && getDurationOfSpecialDate(date) >= 0) {
            return 'available_selected_day'
          }
    
          if (date.getDay() === 5) {
            return 'available_selected_day'
          } else {
            return 'available_day'
          }
        }
    }
  }

  const isDateBooked = (date) => {

    if (appstate.bookings != null) {
      let year = date.getFullYear();
      let formattedYear = 'year' + year;
      let formattedMonth = format(date, "MMMM").toLowerCase();
      let day = date.getDate();

      if (date < new Date()) {
        return true;
      }        

      if (appstate.bookings[formattedYear] && appstate.bookings[formattedYear][formattedMonth]) {
        return appstate.bookings[formattedYear][formattedMonth][day-1];
      }
    }

    return true;
    
  }

  const getPeriod = (date) => {
    var period;
    switch (date.getMonth()) {
      case 0:
      case 1:
      case 2:
      case 9:
      case 10:
      case 11:
        period = "low";
        break;
      case 3:
      case 4:
      case 5:
      case 8:
        period = "shoulder";
        break;
      case 6:
      case 7:
        period = "peak";
        break;
      default:
        period = "low";
    }

    return period;
  }

  const getCost = (date) => {

    const { rates } = appstate;

    let period = getPeriod(date);
    let year = date.getFullYear();
    let formattedYear = 'year' + year;
    let formattedMonth = format(date, "MMMM").toLowerCase();
    let day = date.getDate();

    // Get specific rates if they exist for the start date
    if (rates && rates[formattedYear] && rates[formattedYear][formattedMonth]) {

      if (rates[formattedYear][formattedMonth][day-1] !== 0) {
        return rates[formattedYear][formattedMonth][day-1];
      }
    }

    // Otherwise fall back on the period cost calculation
    var cost;
    switch (period) {
      case "peak":
        cost = 1200;
        break;
      case "shoulder":
        cost = 800;
        break;
      case "low":
        cost = 550;
        break;
      default:
        cost = 600;
        break;
    }
    return cost;
  }

  const getFullCost = (date, duration) => {
    let secondWeekDate = addDays(date, 7);
    let thirdWeekDate = addDays(date, 14);
    let fourthWeekDate = addDays(date, 21);
    var fullCost;

    if (duration == 7) {
      fullCost = getCost(date);
    } else if (duration == 14) {
      fullCost = (getCost(date) + getCost(secondWeekDate));
    } else if (duration == 21) {
      fullCost = (getCost(date) + getCost(secondWeekDate) + getCost(thirdWeekDate));
    } else if (duration == 28) {
      fullCost = (getCost(date) + getCost(secondWeekDate) + getCost(thirdWeekDate) + getCost(fourthWeekDate));
    } else {
      fullCost = getCost(date);
    }
    return fullCost;
  }

  const getTileContent = (date) => {

    var content;
      
    let cost = getCost(date);

    content = <p className="cottage-cost">£{cost}</p>;

    let isSpecialDate = isDateSpecial(date);
    let durationOfSpecialDate = getDurationOfSpecialDate(date);

    // If it is a special start date an not booked then return
    if (isDateBooked(date) === false &&
        isSpecialDate && durationOfSpecialDate > 0) { 
      return content;
    }

    // If it is a special date that cannot be booked return null
    if (isSpecialDate && durationOfSpecialDate === 0) {
      return null;
    }

    if (date.getDay() === 5 && isDateBooked(date) === false) {
      return content;
    }

    return null;
  }

  const isDateSpecial = (date) => {

    const { bookings } = appstate;

    if (bookings != null) { 

      // Is this date a special date
      let thisYear = date.getFullYear();
      let year = 'year' + thisYear;
      let formattedDate = format(date, "yyyyMMdd");

      if (bookings[year].specialDates[formattedDate] >= 0) {
        return true;
      }

      return false;
    }

  }

  const getDurationOfSpecialDate = (date) => {

    const { bookings } = appstate;

    if (bookings != null) { 

      // Is this date a special date
      let thisYear = date.getFullYear();
      let year = 'year' + thisYear;
      let formattedDate = format(date, "yyyyMMdd");

      if (bookings[year].specialDates[formattedDate] >= 0) {
        return bookings[year].specialDates[formattedDate];
      }

      return -1;
    }

  }

  const isDateDisabled = (date) => {

    let isBooked = isDateBooked(date);
    let isSpecialDate = isDateSpecial(date);
    let durationOfSpecialDate = getDurationOfSpecialDate(date);

    if (isBooked) {
      return true
    }

    // If the date is a special start date
    if (isSpecialDate === true && durationOfSpecialDate > 0) {
      return false;
    }

    // If the date is a special start date
    if (isSpecialDate === true && durationOfSpecialDate === 0) {
      return true;
    }
    
    if (date.getDay() !== 5) {
      return true;
    }

    return false;

  }

  const getNextAvailableDate = () => {

    const { bookings } = appstate;

    let now = new Date();
    let thisYear = now.getFullYear();
    let year = 'year' + thisYear;
    let month = now.getMonth();

    if (bookings != null) {
      while (month < 12) {
        // Does the current month have any availability
        switch (month) {
          case 0:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].january[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 1:
            for (let i = 0; i < 28; i++) {
              if (bookings[year].february[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 2:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].march[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 3:
            for (let i = 0; i < 30; i++) {
              if (bookings[year].april[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 4:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].may[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 5:
            for (let i = 0; i < 30; i++) {
              if (bookings[year].june[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 6:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].july[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 7:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].august[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 8:
            for (let i = 0; i < 30; i++) {
              if (bookings[year].september[i] === false) {
                let dateToReturn = new Date(thisYear,month,1);
                return dateToReturn;
              }
            }
            break;
          case 9:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].october[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 10:
            for (let i = 0; i < 30; i++) {
              if (bookings[year].november[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;
          case 11:
            for (let i = 0; i < 31; i++) {
              if (bookings[year].december[i] === false) {
                return new Date(thisYear, month, 1);
              }
            }
            break;   
          }     
        month = month + 1;
      }
      
      return now;
    }

    return now;      
  }

  const getMaxDate = () => {

    let now = new Date();
    let nextYear = now.getFullYear() + 1;

    return new Date(nextYear, 11,31);
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-6 imagesBackgroundColour">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Availability Calendar</h4>
            </div>            
          </div>
            <div className="col-12 d-block d-md-none">
              <div className="row">
                <div className="available-tile" style={{"marginLeft": "1rem"}}></div>
                <div className="keyText">
                    <div className="availabilityTextBox">
                      <p>Available</p>                
                    </div>
                  </div>
                <div className="unavailable-tile menu-col"></div>
                  <div className="keyText">
                  <div className="availabilityTextBox">
                    <p>Unavailable</p>                
                  </div>
                </div>
                <div className="selected-tile menu-col"></div>                
                <div className="keyText">
                  <div className="availabilityTextBox">
                    <p>Selected</p>                
                  </div>
                </div>
              </div>
            </div>
          <div className="col-12 col-md-8 booking-calendar">
            <Calendar 
                    view="month"
                    tileContent={({ date, view }) => {return getTileContent(date)}}                          
                    tileDisabled={({date}) => { return isDateDisabled(date) }}
                    tileClassName={({ date, view }) =>
                        {return isBooked(date)}
                    }
                    showDoubleView={false}
                    showNavigation={true}
                    minDate={new Date()}
                    maxDate={getMaxDate()}
                    onClickDay={(date) => {selectDate(date)}}
                    showNeighboringMonth={false}
                    defaultActiveStartDate={getNextAvailableDate()}
            />
          </div>
          <div className="col-3 d-none d-md-block">
            <div className="row">
                <div className="available-tile"></div>
                <div className="generalText">
                  <div className="availabilityTextBox">
                    <p>Available</p>                
                  </div>
                </div>
            </div>
            <div className="row">
                <div className="unavailable-tile"></div>
                <div className="generalText">
                  <div className="availabilityTextBox">
                    <p>Unavailable</p>                
                  </div>
                </div>
            </div>
            <div className="row">
                <div className="selected-tile"></div>
                <div className="generalText">
                  <div className="availabilityTextBox">
                    <p>Selected</p>                
                  </div>
                </div>
            </div>
          </div>
        </div>
        {getSelectedBooking()}
      </div>
      <div className="d-none d-lg-block col-12 col-lg-6  imagesBackgroundColour">
        <picture>
          <source srcSet={`${blueSkyView_small} 1x,${blueSkyView_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${blueSkyView_medium} 1x,${blueSkyView_large} 2x`}
            src={blueSkyView_medium} alt="View down Loch Hourn from the Cottage" className="gallery-image"
          />
        </picture>
      </div>
    </div>
  );
}

export default DirectBooking
